export default "__VITE_ASSET__DAF1jhZ1__"